import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { c } from '@debbie/cortex/dist';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
import THEME from '../../theme';
import Panel from '../Panel';
import SelectableEntities from './SelectableEntities';
const AccountSelectorPage = () => {
    const me = useSelector(selectMe);
    useEffect(() => {
        c.me.get();
    }, []);
    return (React.createElement(StyledPage, null,
        React.createElement(SelectorWrapper, null,
            React.createElement(Panel, null, me ? React.createElement(SelectableEntities, { tenants: me.tenants }) : React.createElement(React.Fragment, null)))));
};
export default AccountSelectorPage;
const StyledPage = styled.div `
  background-color: ${THEME.BACKGROUND};

  height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
const SelectorWrapper = styled.div `
  max-width: 400px;
  margin: 100px auto 0 auto;
`;
//# sourceMappingURL=AccountSelectorPage.js.map